import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingbuttonComponent} from '~/app/web/sharedcomponents/loadingbutton/loadingbutton.component';
import {MatButtonModule} from '@angular/material/button';

@NgModule({
    declarations: [
        LoadingbuttonComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule
    ],
    exports: [
        LoadingbuttonComponent
    ]
})
export class SharedcomponentsModule {
}
